import { render, staticRenderFns } from "./SpeciesForm.vue?vue&type=template&id=0c3ab3d2&"
import script from "./SpeciesForm.vue?vue&type=script&lang=js&"
export * from "./SpeciesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports